import { createAsyncThunk, createSlice, EntityState } from '@reduxjs/toolkit';
import { fetchSavedSearchCriterias } from 'api/search-criteria.service';
import { SavedSearchCriteriaResponse } from 'types/entity';
import { searchCriteriaReadAdapter } from './search-criteria-read.adapter';

export const SEARCH_CRITERIA_READ_NAME = 'searchCriteriaRead';

export const loadSearchCriterias = createAsyncThunk(
  `${SEARCH_CRITERIA_READ_NAME}/load`,
  async (projectId: string) => {
    const response = await fetchSavedSearchCriterias(projectId);
    return response;
  },
);

export interface SearchCriteriaReadState extends EntityState<SavedSearchCriteriaResponse> {
  /** 検索条件管理画面から編集中か */
  inManagement: boolean
  loaded: boolean
  error: any
}

const initialState = {
  inManagement: false,
  loaded: false,
  error: null,
};
export const initialSearchCriteriaReadState: SearchCriteriaReadState = searchCriteriaReadAdapter.getInitialState(initialState);

export const searchCriteriaReadSlice = createSlice({
  name: SEARCH_CRITERIA_READ_NAME,
  initialState: initialSearchCriteriaReadState,
  reducers: {
    managementStart: (state) => {
      state.inManagement = true;
    },
    managementEnd: (state) => {
      state.inManagement = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadSearchCriterias.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadSearchCriterias.fulfilled, (state, action) => {
      searchCriteriaReadAdapter.setAll(state, action.payload);
      state.loaded = true;
    });
    builder.addCase(loadSearchCriterias.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
  },
});

export const searchCriteriaReadAction = {
  ...searchCriteriaReadSlice.actions,
  loadSearchCriterias,
};

export default searchCriteriaReadSlice.reducer;
